module.exports = __webpack_public_path__ + "img/Reg-6-CongressExp.8e3a4041.svg";